import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../_services';
import { Dependent } from '../_models/dependent.model';
import { MatMenuTrigger, MatDialog } from '@angular/material';
import { DependentFormComponent } from './dependent-form/dependent-form.component';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';
import { title } from 'process';
import * as $ from 'jquery';
import { DependentService } from '../_services/dependent.service';
import { MemberService } from '../_services/member.service';

@Component({
  selector: 'app-dependent',
  templateUrl: './dependent.component.html',
  styleUrls: ['./dependent.component.scss']
})
export class DependentComponent implements OnInit {
  @ViewChild('notificationBlockDependent') notificationBlockDependent : ElementRef;

  listDependents = []
  public notification = {
    message: '',
  }
  currentMember: any;
  isLoading = true;
  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private dependentService: DependentService,
    public dialog: MatDialog,
    private memberService: MemberService
    ) { 
      this.currentMember =  JSON.parse(localStorage.getItem('currentMember'));

    }

  ngOnInit() {
    this.getDependents();
  }

  getDependents(){
    this.isLoading = true;
    this.dependentService.getDependents(this.currentMember.memberId).subscribe(r=>{
      // console.log(r)
      this.listDependents = r;
      this.isLoading = false;
    })
  }

  // addDependent(dependent: Dependent, index?){
  //   if (index != null) {
  //     this.listDependents.splice(index,1,dependent);
  //     return
  //   }
  //   this.listDependents.push(dependent)
  // }

  createEditDependent(dependent?: any){
      let dialogRef;

         dialogRef = this.dialog.open(DependentFormComponent,{
            panelClass: 'col-md-6',
            data: {
              currentDependent: dependent ,
            }
        })
      
     
    dialogRef.afterClosed().subscribe(r=>{
      if (r) {
        //get list to refresh
        console.log(r)
        this.getDependents();
        if (r.over18) {
          this.onShowNotification()
        }
      }
       
    })
  }

  onDeleteDependent(id){
    let dialogRef = this.dialog.open(ConfirmDialogComponent,{
      panelClass: 'col-sm-6',
      width: '300px',
      height: '200px',
      data:{
        title: "Warning !",
        message: "Delete Dependent ?"
      }
    })

    dialogRef.afterClosed().subscribe(r=>{
      if(r){
        this.dependentService.deleteDependent(id).subscribe(r=>{
          this.getDependents();
        })
      }
    })
  }

  onContinue(){
    $(this.notificationBlockDependent.nativeElement).hide(500)
  }
  onShowNotification(){
    console.log('onshow ')
    $(this.notificationBlockDependent.nativeElement).show(1000)
  }
  // checkEmailInput(email){
  //   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   console.log(re.test(email));
  //   if(re.test(email)){
  //     this.formValidEmail = true;
  //   }

  // }

}



// WEBPACK FOOTER //
// ./src/app/dependent/dependent.component.ts